<template>
  <v-chip
    v-if="scheduled"
    x-small
    color="#6a1b9a"
    text-color="white"
    class="ml-1 scheduled-unit-badge"
  >
    📅 SCHEDULED<template v-if="formattedDate"> - {{ formattedDate }}</template>
  </v-chip>
</template>

<script>
import { convertToLuxonDT } from "@tod-ui/helpers/datetime";

export default {
  name: "ScheduledUnitBadge",
  props: {
    scheduled: {
      type: Boolean,
      default: false,
    },
    moveInAt: {
      type: String,
      default: null,
    },
    timeZone: {
      type: String,
      default: null,
    },
  },
  computed: {
    // Abbreviated month + day (e.g. "JUL 15"), rendered in the FACILITY timezone,
    // no year — matches the SD-2367 Smart Units / Dashboard mockup.
    formattedDate() {
      if (!this.moveInAt) return "";

      return convertToLuxonDT(this.moveInAt, this.timeZone)
        .toFormat("MMM d")
        .toUpperCase();
    },
  },
};
</script>
